import {isPlatform} from '@ionic/vue'

export const isNative = () => {
  return isPlatform('hybrid')
}
